(function paycheckRRHHAddControllerDefinition() {
    'use strict';

    angular.module('Paycheck')
        .controller('PaycheckRRHHAddController', [
            '$filter', '$state', '$scope', 'errorsExtend', 'processService', 'processBatchService', 'configViewService', 'fileService', 'authExtend', 'messages', 'organizationalUnitService', '$q',
            function paycheckRRHHAddController($filter, $state, $scope, errors, processService, processBatchService, configViewService, fileService, auth, messages, organizationalUnitService, $q) {
                $scope.preview = {
                    closed: true,
                    loading: false,
                    content: null,
                    index: null,
                    item: null,
                    invalid: false
                };

                $scope.hasAlternatePaycheckConfig = false;

                $scope.addFile = function () {
                    $scope.aux.filesTemp.forEach(function (file) {
                        if (file && file.size) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            if (file.name.toLowerCase().indexOf(".pdf") > 0) {
                                var index = $scope.getIndexFile(file);
                                if (~index) {
                                    $scope.aux.files[index] = file;
                                } else {
                                    $scope.aux.files.push(file);
                                }
                            }
                        }
                    });

                    $scope.aux.filesTemp = [];
                };

                $scope.getIndexFile = function (fileNew) {
                    for (var i in $scope.aux.files) {
                        if ($scope.aux.files.hasOwnProperty(i)) {
                            var fileOld = $scope.aux.files[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    };

                    return -1;
                };

                $scope.cancel = function () {
                    $state.go('paycheck-rrhh-find');
                };

                $scope.removeFile = function (file) {
                    var index = $scope.getIndexFile(file);

                    if (~index) {
                        if ($scope.preview.index == index) {
                            $scope.hidePreview();
                        }
                        $scope.aux.files.splice(index, 1);
                    }
                };

                $scope.loadViewOptions = function () {
                    if (!$scope.processTypes || $scope.processTypes.length < 1) {

                        $q.all([configViewService.getById("CPPPaycheckRRHH"),
                            organizationalUnitService.getConfig(auth.getOrganizationId(), '#OuConfigRSD')]).then(function (results) {

                            if (results[0].processTypes && results[0].processTypes.length > 0) {
                                    $scope.paycheckConfig = results[1];
                                    $scope.processTypes = [];
                                    angular.forEach(results[0].processTypes, function (item) {
                                        $scope.loadMetadata(item);
                                    });
                                    var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                                    $scope.processType = found[0] || $scope.processTypes[0];
                            }
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.loadMetadata = function (item) {
                    var processType = {
                        name: item.name,
                        id: item.processTypeId,
                        preSelected: item.preSelected,
                        metadatas: []
                    };

                    item.metadatas.forEach(function (metadata) {
                        if (metadata.createCriteria) {
                            var data = {
                                idObject: item.name.replace(/ /g, '_') + metadata.systemName,
                                metadataId: metadata.metadataId,
                                metadataValueFrom: undefined,
                                metadataValueTo: undefined,
                                metadataSearchTypeFrom: undefined,
                                metadataSearchTypeTo: undefined,
                                metadataType: metadata.metadataType != null ? metadata.metadataType.toLowerCase() : undefined,
                                metadataSystemName: metadata.systemName,
                                metadataLabel: metadata.createCriteria.name,
                                metadataReadOnly: !metadata.createCriteria.isEditable,
                                metadataEnabled: true,
                                metadataIsVisible: true,
                                metadataOptions: metadata.metadataOptionValues,
                                metadataIsRequired: metadata.createCriteria.isRequired,
                                maskOptions: metadata.metadataMaskOption,
                                order: metadata.createCriteria.order
                            };

                            if (metadata.systemName === '_modFirma') {
                                data.metadataIsVisible = false;
                                data.metadataValue = 'FD';
                            }

                            if (metadata.systemName === '_trec') {
                                if ($scope.paycheckConfig && $scope.paycheckConfig['#PaycheckTypeOptions']) {
                                    var docTypes = $scope.paycheckConfig['#PaycheckTypeOptions'].split(',');
                                    data.metadataOptions = data.metadataOptions.filter(function (i) {
                                        return docTypes.indexOf(i.value) >= 0;
                                    });
                                }
                            }

                            processType.metadatas.push(data);
                        }
                    });

                    processType.metadatas.sort(function (a, b) {
                        return a.order - b.order;
                    });

                    $scope.processTypes.push(processType);
                };

                $scope.selectProcessType = function (processType) {
                    $scope.processType = processType;
                };

                $scope.createDeferedProcess = function () {
                    var paychecks = [];
                    var metadataValues = [];

                    var metadatas = $scope.processType.metadatas;
                    for (var i = 0; i < metadatas.length; i++) {
                        if (metadatas[i].metadataSystemName === '_peri' && metadatas[i].metadataValue) {
                            var year = metadatas[i].metadataValue.substring(0, 4);
                            var month = metadatas[i].metadataValue.substring(4);

                            if (year < 1900 || month < 1 || month > 12) {
                                errors.showError('VerifyPeriodFormat');
                                return false;
                            }
                        }

                        metadataValues.push({ systemName: metadatas[i].metadataSystemName, value: metadatas[i].metadataValue });
                    }

                    $scope.aux.files.forEach(function (file) {
                        var paycheck = {};
                        paycheck.name = file.name;
                        paycheck.processTypeId = $scope.processType.id;
                        paycheck.from = 'RRHHRecibos';
                        paycheck.organizationalUnitId = $scope.organizationalUnit.id;
                        paycheck.metadataValues = metadataValues;
                        paychecks.push(paycheck);
                    });

                    var processBatch = {
                        processTypeId: '001',
                        organizationalUnitId: $scope.organizationalUnit.id,
                        organizationalUnitName: $scope.organizationalUnit.name,
                        data: {
                            parameters: paychecks
                        }
                    };

                    return processBatchService.create(processBatch, $scope.aux.files).then(function (result) {
                        if (result.status === 200) {
                            $scope.preview.loading = false;
                            messages.showSuccess('PaycheckProcessBatch');
                            $state.go('paycheck-rrhh-find');
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.save = function () {
                    if (!$scope.paycheckRRHHAdd.$valid) {
                        $scope.paycheckRRHHAdd.$setSubmitted();
                        return errors.showError('VerifyFormData') || false;
                    }

                    if ($scope.aux.files.length <= 0) {
                        return errors.showError('VerifyFormFile') || false;
                    }
                    if (!$scope.hasAlternatePaycheckConfig) {
                        return organizationalUnitService.getConfig($scope.organizationalUnit.id, '#OuConfigSectionPaychecks').then(function (result) {
                            if (!angular.equals(result, {})) {
                                var metadata = $filter('filter')($scope.processTypes[0].metadatas, { metadataSystemName: '_modFirma' }, true);
                                if (result && result['#RequireSignatureRE'] === 'REN') {
                                    metadata[0].metadataValue = 'SF';
                                } else {
                                    metadata[0].metadataValue = 'FD';
                                }

                                return $scope.createDeferedProcess();
                            } else {
                                errors.showError('PaycheckConfigNotDefinedError');
                            }
                        }, function (error) {
                            if (error.status === 404) {
                                errors.showError('PaycheckConfigNotDefinedError');
                            } else {
                                errors.showError(error);
                            }
                        });
                    } else {
                        return $scope.createDeferedProcess();
                    }
                };

                $scope.load = function () {
                    $scope.organizationalUnitId = 0;
                    $scope.paycheckConfig = {};
                    $scope.aux = {
                        files: [],
                        filesTemp: [],
                        metadataReplicate: [],
                    };

                    $scope.loadViewOptions();
                };

                $scope.load();

                $scope.control = function (value, idOu) {
                    if (value.metadataSystemName === '_trec' && value.metadataValue) {
                        $scope.preview.loading = true;
                        var metadata = $filter('filter')($scope.processTypes[0].metadatas, { metadataSystemName: '_modFirma' }, true);

                        organizationalUnitService.getConfig(idOu || $scope.organizationalUnit.id, '#OuConfigRA' + value.metadataValue).then(function (result) {
                            $scope.hasAlternatePaycheckConfig = !angular.equals(result, {});
                            $scope.preview.loading = false;
                            if (result && result['#RequireSignatureRA'] === 'RAN') {
                                metadata[0].metadataValue = 'SF';
                            } else {
                                metadata[0].metadataValue = 'FD';
                            }
                        });
                    }
                };

                $scope.$watch('organizationalUnit', function (newOu) {
                    if (newOu === undefined || $scope.processType === undefined) {
                        return;
                    }

                    var metadata = $filter('filter')($scope.processTypes[0].metadatas, { metadataSystemName: '_trec' }, true);

                    $scope.control(metadata[0], newOu.id);
                });
            }

        ]);
})();
